import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.js'
import error from './error.js'
import official from './official.js'
import loading from './loading.js'
import task from './task.js'
import item from './item.js'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    error,
    official,
    loading,
    task,
    item,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'projMituketa',
      paths:[
        'auth',
        'item.urgencys',
        'item.users',
        'item.status',
        'item.devices',
      ]
    })
  ]
})

export default store